import useSWR from "swr";
import getBuyerAPIDomain from "../../getBuyerAPIDomain";
import { ISavedSearchItem } from "../save-search.types";
import getSavedSearches from "./getSavedSearches";
import { StoreType } from "../../StoreType";
import { useSelector } from "react-redux";
import { GET_STATE } from "../../redux/slices/appSlice";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

export function useSavedSearchList(loadingTimeout?: number) {
  const {
    app: { isToUseAuthZero },
  }: StoreType = useSelector(GET_STATE);
  const { accessToken } = useAuth(!isToUseAuthZero);
  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);

  const url = buyerAPIDomain
    ? new URL(`${buyerAPIDomain.href}/SavedSearch/list`, buyerAPIDomain)
    : null;

  const { data, error } = useSWR<ISavedSearchItem[]>(
    accessToken || !isToUseAuthZero
      ? [url.href, accessToken, isToUseAuthZero]
      : null,
    getSavedSearches,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      loadingTimeout,
    }
  );

  return { data, error };
}

export default useSavedSearchList;
